// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file transportation/v1/trailer_events.proto (package transportation.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Trailer, TrailerStatus } from "./trailer_pb.js";
import { file_transportation_v1_trailer } from "./trailer_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file transportation/v1/trailer_events.proto.
 */
export const file_transportation_v1_trailer_events: GenFile = /*@__PURE__*/
  fileDesc("CiZ0cmFuc3BvcnRhdGlvbi92MS90cmFpbGVyX2V2ZW50cy5wcm90bxIRdHJhbnNwb3J0YXRpb24udjEikAIKDFRyYWlsZXJFdmVudBI5CgdjcmVhdGVkGAEgASgLMiYudHJhbnNwb3J0YXRpb24udjEuVHJhaWxlckNyZWF0ZWRFdmVudEgAEjkKB3VwZGF0ZWQYAiABKAsyJi50cmFuc3BvcnRhdGlvbi52MS5UcmFpbGVyVXBkYXRlZEV2ZW50SAASOQoHZGVsZXRlZBgDIAEoCzImLnRyYW5zcG9ydGF0aW9uLnYxLlRyYWlsZXJEZWxldGVkRXZlbnRIABJGCg5zdGF0dXNfY2hhbmdlZBgEIAEoCzIsLnRyYW5zcG9ydGF0aW9uLnYxLlRyYWlsZXJTdGF0dXNDaGFuZ2VkRXZlbnRIAEIHCgVldmVudCJCChNUcmFpbGVyQ3JlYXRlZEV2ZW50EisKB3RyYWlsZXIYASABKAsyGi50cmFuc3BvcnRhdGlvbi52MS5UcmFpbGVyIoABChNUcmFpbGVyVXBkYXRlZEV2ZW50EjQKEHByZXZpb3VzX3RyYWlsZXIYASABKAsyGi50cmFuc3BvcnRhdGlvbi52MS5UcmFpbGVyEjMKD3VwZGF0ZWRfdHJhaWxlchgCIAEoCzIaLnRyYW5zcG9ydGF0aW9uLnYxLlRyYWlsZXIiQgoTVHJhaWxlckRlbGV0ZWRFdmVudBIrCgd0cmFpbGVyGAEgASgLMhoudHJhbnNwb3J0YXRpb24udjEuVHJhaWxlciK5AQoZVHJhaWxlclN0YXR1c0NoYW5nZWRFdmVudBIrCgd0cmFpbGVyGAEgASgLMhoudHJhbnNwb3J0YXRpb24udjEuVHJhaWxlchI5Cg9wcmV2aW91c19zdGF0dXMYAiABKA4yIC50cmFuc3BvcnRhdGlvbi52MS5UcmFpbGVyU3RhdHVzEjQKCm5ld19zdGF0dXMYAyABKA4yIC50cmFuc3BvcnRhdGlvbi52MS5UcmFpbGVyU3RhdHVzQkFaP3BhY2thZ2VzL2JhY2tlbmQtbW9kdWxlLXRyYW5zcG9ydGF0aW9uL2FwaS92MTt0cmFuc3BvcnRhdGlvbl92MWIIZWRpdGlvbnNw6Ac", [file_transportation_v1_trailer]);

/**
 * @generated from message transportation.v1.TrailerEvent
 */
export type TrailerEvent = Message<"transportation.v1.TrailerEvent"> & {
  /**
   * @generated from oneof transportation.v1.TrailerEvent.event
   */
  event: {
    /**
     * @generated from field: transportation.v1.TrailerCreatedEvent created = 1;
     */
    value: TrailerCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: transportation.v1.TrailerUpdatedEvent updated = 2;
     */
    value: TrailerUpdatedEvent;
    case: "updated";
  } | {
    /**
     * @generated from field: transportation.v1.TrailerDeletedEvent deleted = 3;
     */
    value: TrailerDeletedEvent;
    case: "deleted";
  } | {
    /**
     * @generated from field: transportation.v1.TrailerStatusChangedEvent status_changed = 4;
     */
    value: TrailerStatusChangedEvent;
    case: "statusChanged";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message transportation.v1.TrailerEvent.
 * Use `create(TrailerEventSchema)` to create a new message.
 */
export const TrailerEventSchema: GenMessage<TrailerEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_trailer_events, 0);

/**
 * @generated from message transportation.v1.TrailerCreatedEvent
 */
export type TrailerCreatedEvent = Message<"transportation.v1.TrailerCreatedEvent"> & {
  /**
   * @generated from field: transportation.v1.Trailer trailer = 1;
   */
  trailer?: Trailer;
};

/**
 * Describes the message transportation.v1.TrailerCreatedEvent.
 * Use `create(TrailerCreatedEventSchema)` to create a new message.
 */
export const TrailerCreatedEventSchema: GenMessage<TrailerCreatedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_trailer_events, 1);

/**
 * @generated from message transportation.v1.TrailerUpdatedEvent
 */
export type TrailerUpdatedEvent = Message<"transportation.v1.TrailerUpdatedEvent"> & {
  /**
   * @generated from field: transportation.v1.Trailer previous_trailer = 1;
   */
  previousTrailer?: Trailer;

  /**
   * @generated from field: transportation.v1.Trailer updated_trailer = 2;
   */
  updatedTrailer?: Trailer;
};

/**
 * Describes the message transportation.v1.TrailerUpdatedEvent.
 * Use `create(TrailerUpdatedEventSchema)` to create a new message.
 */
export const TrailerUpdatedEventSchema: GenMessage<TrailerUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_trailer_events, 2);

/**
 * @generated from message transportation.v1.TrailerDeletedEvent
 */
export type TrailerDeletedEvent = Message<"transportation.v1.TrailerDeletedEvent"> & {
  /**
   * @generated from field: transportation.v1.Trailer trailer = 1;
   */
  trailer?: Trailer;
};

/**
 * Describes the message transportation.v1.TrailerDeletedEvent.
 * Use `create(TrailerDeletedEventSchema)` to create a new message.
 */
export const TrailerDeletedEventSchema: GenMessage<TrailerDeletedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_trailer_events, 3);

/**
 * @generated from message transportation.v1.TrailerStatusChangedEvent
 */
export type TrailerStatusChangedEvent = Message<"transportation.v1.TrailerStatusChangedEvent"> & {
  /**
   * @generated from field: transportation.v1.Trailer trailer = 1;
   */
  trailer?: Trailer;

  /**
   * @generated from field: transportation.v1.TrailerStatus previous_status = 2;
   */
  previousStatus: TrailerStatus;

  /**
   * @generated from field: transportation.v1.TrailerStatus new_status = 3;
   */
  newStatus: TrailerStatus;
};

/**
 * Describes the message transportation.v1.TrailerStatusChangedEvent.
 * Use `create(TrailerStatusChangedEventSchema)` to create a new message.
 */
export const TrailerStatusChangedEventSchema: GenMessage<TrailerStatusChangedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_trailer_events, 4);

